import {Cookies} from 'react-cookie';
import {
    COMMENTS_DOWNLOADED,
    COMMENTS_PENDING,
    COMMENTS_FAILED,
    COMMENT_FAILED,
    COMMENT_POSTING,
    COMMENT_DELETING,
    COMMENTS_RESET,
    COMMENT_DELETED
} from './types';
import APIService from '../../services/api'
import {handleError} from '../infos/actions'

const cookies = new Cookies();

// Action creators

export const resetCommentsAction = () => {
    return {type: COMMENTS_RESET};
};

export const commentsPendingAction = () => {
    return {type: COMMENTS_PENDING};
};

export const commentPostingAction = () => {
    return {type: COMMENT_POSTING};
};

export const commentDeletedAction = (id) => {
    return {
        type: COMMENT_DELETED,
        payload: id
    };
};

export const commentDeletingAction = () => {
    return {type: COMMENT_DELETING};
};

export const commentsDownloadedAction = (comments) => {
    return {
        type: COMMENTS_DOWNLOADED,
        payload: comments
    };
};

// Actions

export function resetComments() {
    return function (dispatch) {
        dispatch(resetCommentsAction());
    }
}

export function rejectComment(appId, comment) {
    return function (dispatch, getState) {
        dispatch(commentPostingAction());
        return APIService
            .putComment(appId, comment.id, false, cookies.get('token'))
            .then(comment => {
                dispatch(commentDeletedAction(comment.id));
            })
            .catch((error) => {
                dispatch(handleError(error, COMMENT_FAILED))
            });
    }
}

export function acceptComment(appId, comment) {
    return function (dispatch, getState) {
        dispatch(commentPostingAction());
        return APIService
            .putComment(appId, comment.id, true, cookies.get('token'))
            .then(comment => {
                dispatch(commentDeletedAction(comment.id));
            })
            .catch((error) => {
                dispatch(handleError(error, COMMENT_FAILED))
            });
    }
}

export function getComments(appId) {
    return function (dispatch, getState) {
        dispatch(commentsPendingAction());
        return APIService
            .getComments(appId, cookies.get('token'))
            .then(comments => {
                dispatch(commentsDownloadedAction(comments));
            })
            .catch((error) => {
                dispatch(handleError(error, COMMENTS_FAILED))
            });
    }
}

export function deleteComment(appId, commentId) {
    return function (dispatch) {
        dispatch(commentDeletingAction());
        return APIService
            .deleteComment(appId, commentId, cookies.get('token'))
            .then(() => {
                dispatch(commentDeletedAction(commentId));
            })
            .catch((error) => {
                dispatch(handleError(error, COMMENT_FAILED))
            });
    }
}




// WEBPACK FOOTER //
// src/store/comments/actions.js